import { render } from "./PhoneCallCard.vue?vue&type=template&id=a2dfc1be&scoped=true"
import script from "./PhoneCallCard.vue?vue&type=script&lang=js"
export * from "./PhoneCallCard.vue?vue&type=script&lang=js"

import "./PhoneCallCard.vue?vue&type=style&index=0&id=a2dfc1be&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2dfc1be"]])

export default __exports__